import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37b79483"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PReference_Operation_Container" }
const _hoisted_2 = { class: "paging_container" }
const _hoisted_3 = { class: "btn_container" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "loading"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "loading"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "アップロード", -1))
const _hoisted_9 = { class: "PReference_Table" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_SyosiInfo PReference_Table_Sticky_TH1 PReference_Table_Wide" }, [
      /*#__PURE__*/_createTextVNode(" 書誌CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ISBN ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Sticky_TH2 PReference_Table_Wide" }, " 書誌名 "),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Bikou PReference_Table_Wide" }, [
      /*#__PURE__*/_createTextVNode(" 商品備考"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(表示期限) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Bikou PReference_Table_Wide" }, [
      /*#__PURE__*/_createTextVNode(" VAN強制ST"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(表示期限) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "良品"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "返品"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("本体"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("価格")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "ISBN13桁"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "取置"),
    /*#__PURE__*/_createElementVNode("th", null, "当日受注入力数"),
    /*#__PURE__*/_createElementVNode("th", null, "保留合計"),
    /*#__PURE__*/_createElementVNode("th", null, "シリーズ名"),
    /*#__PURE__*/_createElementVNode("th", null, "カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Middle" }, "現在在庫ST"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Middle" }, "発売日"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "スリップ"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "カバー"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "帯"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "ケース"),
    /*#__PURE__*/_createElementVNode("th", null, "改装出来予定日"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "改装出来予定数"),
    /*#__PURE__*/_createElementVNode("th", null, "重版出来予定日"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "重版出来予定数"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "最新刷数"),
    /*#__PURE__*/_createElementVNode("th", { class: "PReference_Table_Narrow" }, "断裁"),
    /*#__PURE__*/_createElementVNode("th", null, "著者")
  ])
], -1))
const _hoisted_11 = { class: "PReference_Table_SyosiInfo PReference_Table_Sticky_TD1 Text_Left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "PReference_Table_SyosiInfo PReference_Table_Sticky_TD2 Text_Left" }
const _hoisted_14 = { class: "PReference_Table_Bikou" }
const _hoisted_15 = { class: "PReference_Table_Flex" }
const _hoisted_16 = { class: "PReference_Table_Bikou_Text" }
const _hoisted_17 = { class: "PReference_TextHL" }
const _hoisted_18 = {
  key: 0,
  class: "PReference_TextHL"
}
const _hoisted_19 = {
  key: 1,
  class: "PReference_TextHL"
}
const _hoisted_20 = { class: "PReference_Table_Bikou" }
const _hoisted_21 = { class: "PReference_Table_Flex" }
const _hoisted_22 = { class: "PReference_Table_Bikou_Text" }
const _hoisted_23 = { class: "PReference_TextHL" }
const _hoisted_24 = {
  key: 0,
  class: "PReference_TextHL"
}
const _hoisted_25 = {
  key: 1,
  class: "PReference_TextHL"
}
const _hoisted_26 = { class: "Text_Red" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "ResultMessageNull"
}

import OrderHeader from "../components/OrderHeader.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import ModalOrderSearchMemo from "../components/modal/ModalOrderSearchMemo.vue";
import ModalOrderSearchVan from "../components/modal/ModalOrderSearchVan.vue";
import { ref, reactive } from "vue";
import { useStore } from "vuex";
import Paginate from "vuejs-paginate-next";
import { Notyf } from "notyf";
import axios from "axios";

// 型定義---------------------------------------------------------------------------
export interface ZaikoData {
  author: string | null;
  bookCase: number | null;
  category: string | null;
  cover: number | null;
  cutting: boolean | null;
  fromUpdateStatusDate: string | null;
  holdSum: number | null;
  hontaiPrice: number | null;
  inputSum: number | null;
  isbn: string | null;
  itemRemarks: string | null;
  items: number | null;
  janCd: string | null;
  juhanSchduledDate: string | null;
  juhanSchduledQuantity: number | null;
  kaisoSchduledDate: string | null;
  kaisoSchduledQuantity: number | null;
  kosinUpdateDate: string | null;
  kosinUserId: number | null;
  latestPrints: number | null;
  naiyo: string | null;
  obi: number | null;
  releaseDate: string | null;
  remarksDeadline: string | null;
  returnItems: number | null;
  series: string | null;
  slip: number | null;
  syosiCd: string | null;
  syubetu: number | null;
  teikaUpdateDate: Date | null;
  title: string;
  titleKana: string | null;
  toUpdateStatusDate: string | null;
  torioki: number | null;
  vanStatusName: number | null; // updateStatus
  vanStatusId: number | null;
  zsName: string | null;
}
export interface SelectedProductType {
  syosiCd: string | null;
  title: string;
  janCd: string | null;
  itemRemarks: string | null; // 備考
  remarksDeadline: string | null; // 備考表示期限
  updateStatus: number | null; // VAN強制ST
  vanStatusId: number | null; // VAN強制STの強制ステータス用
  fromUpdateStatusDate: string | null; // 表示期限開始日（VAN強制ST）
  toUpdateStatusDate: string | null; //  表示期限終了日（VAN強制ST）
}

// const router = useRouter();

export default /*#__PURE__*/_defineComponent({
  __name: 'EditProductStatus',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props) {

const store = useStore();
const notyf = new Notyf();

// axiosのグローバル設定（トークンの書き換え方法がわからないので未設定）
// const axios = inject<any>("$axios");

const props = __props;


//ぱんくずヘッダー
const currentPathList = [{ name: "製品マスタ" }, { name: "商品ステータス" }];

// ストアの初期化------------------------------------------------
store.commit("search/clearAuthData");
// テーブル表示項目----------------------------------------------
let searchAreaToggle: boolean = true;
let search_result = ref<ZaikoData[]>([]);
//検索ヘッダ関連----------------------------------------------
let isActive_KaniFlg = ref<boolean>(false);
let isActive_SyosaiFlg = ref<boolean>(true);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActive_KaniFlg.value = KaniFlg;
};
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};
const onSearch = () => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  getZaikoData();
};
// 開閉時の処理
let isOpentoggleArea = ref<boolean>(true);
const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};
//テーブルの高さ判定
const tableHeight = () => {
  if (isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "PReference_TableContainer_Short";
  } else {
    //その他
    return "PReference_TableContainer_Long";
  }
};

// モーダル関連----------------------------------------------
let selectedProduct = reactive<SelectedProductType>({
  syosiCd: "",
  title: "",
  janCd: "",
  itemRemarks: "",
  remarksDeadline: "",
  updateStatus: -1,
  vanStatusId: null,
  fromUpdateStatusDate: "",
  toUpdateStatusDate: "",
});
//備考
let modalVisible_memo = ref<boolean>(false);
const updateBikou = () => {
  getZaikoData();
};
//van強制ST
let modalVisible_van = ref<boolean>(false);
const updateStatus = () => {
  getZaikoData();
};
const showModal = (ModalName: string, product: ZaikoData): void => {
  selectedProduct.syosiCd = product.syosiCd;
  selectedProduct.title = product.title;
  selectedProduct.janCd = product.janCd;
  selectedProduct.itemRemarks = product.itemRemarks;
  selectedProduct.remarksDeadline = product.remarksDeadline;
  selectedProduct.vanStatusId = product.vanStatusId;
  selectedProduct.updateStatus = product.vanStatusName;
  selectedProduct.fromUpdateStatusDate = product.fromUpdateStatusDate;
  selectedProduct.toUpdateStatusDate = product.toUpdateStatusDate;
  if (ModalName === "ModalOrderSearchMemo") {
    modalVisible_memo.value = true;
  } else if (ModalName === "ModalOrderSearchVan") {
    modalVisible_van.value = true;
  }
};
const closeModal = (): void => {
  if (modalVisible_memo.value) {
    modalVisible_memo.value = false;
  } else if (modalVisible_van.value) {
    modalVisible_van.value = false;
  }
};

// 在庫データ取得------------------------------------------------------------
const getZaikoData = async () => {
  search_result.value.splice(0);
  await store.dispatch("search/searchZaiko");
  const res = store.getters["search/getZaikoData"];
  res.syosiList.forEach((syosi: ZaikoData) => {
    search_result.value.push(syosi);
  });
  numberOfTotalData.value = res.size;
  firstCount.value = res.firstCount;
  finalCount.value = res.finalCount;

  getTotalPage();
};
getZaikoData();

// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
// 総ページ数
const numberOfTotalPage = ref(0);
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);
// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getZaikoData();
};

// Excel関連------------------------------------------------
// ダウンロード関連--------------------
const isDownloading = ref(false); // ダウンロード中フラグ
// ダウンロード処理
const downloadFile = async () => {
  isDownloading.value = true;
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi/downloadeExcelTemplate`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    let blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `商品ステータス入力.xlsx`;
    link.click();
    isDownloading.value = false;
  } catch (error) {
    isDownloading.value = false;
    console.log(error);
    alert("ダウンロードに失敗しました");
  }
};
// アップロード関連--------------------
const isUploading = ref(false); // アップロード中フラグ
const inputFile = ref();
// let error = reactive({
//   hasError: false,
//   message: "",
// });
// watch(
//   () => error,
//   () => {
//     if (error.hasError === true) {
//       isUploading.value = false;
//       notyf.error({
//         duration: 10000,
//         message: error.message,
//       });
//     }
//   },
//   { deep: true }
// );
const onClickUpload = () => {
  //「アップロード」ボタンを押下すると非表示中のinput=fileが発火する
  inputFile.value.click();
};
const resetFile = (e: any) => {
  e.target.value = "";
  // error.hasError = false;
  // error.message = "";
};
let FILE: any;
const uploadFile = (e: any) => {
  isUploading.value = true;
  FILE = e.target.files[0];
  const READER = new FileReader();

  READER.onload = async (e: any) => {
    const formData = new FormData();
    formData.append("multipartFile", FILE);
    uploadToServer(formData);
  };
  // Fileオブジェクトバイナリデータとしてメモリ上に読み込む（読み込んだらonload部分を実行する）
  READER.readAsArrayBuffer(FILE);
};

// サーバーに投げる
const uploadToServer = async (sendData: any) => {
  const url = `${store.getters["getBaseUrl"]}/syosi/uploadExcel`;
  try {
    const res = await axios.post(url, sendData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "content-type": "multipart/form-data",
      },
    });
    getZaikoData();
    isUploading.value = false;
    notyf.success("商品ステータスを更新しました");
  } catch (error) {
    isUploading.value = false;
    // 404エラーの場合（DBに存在しないデータが入力された場合）、エラー内容をExcelでダウンロードする
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      // エラー内容のダウンロード
      notyf.error({
        duration: 10000,
        message: error.response?.data.userMessage,
      });
      downloadErrorFile(error.response?.data);
    } else if (axios.isAxiosError(error) && error.response?.data.userMessage) {
      console.log(error);
      notyf.error({
        duration: 10000,
        message: error.response?.data.userMessage,
      });
    } else {
      console.log(error);
      alert("アップロードに失敗しました");
    }
    getZaikoData();
  }
};
// エラーExcelのダウンロード
const downloadErrorFile = async (errorInfo: any) => {
  isUploading.value = true;
  const formData = new FormData();
  formData.append("file", FILE);
  formData.append(
    "errorJanCdCellList",
    new Blob([JSON.stringify(errorInfo.errorJanCdCellList)], {
      type: "application/json",
    })
  );
  formData.append(
    "errorStatusCellList",
    new Blob([JSON.stringify(errorInfo.errorStatusCellList)], {
      type: "application/json",
    })
  );
  try {
    const res = await axios.post(
      `${store.getters["getBaseUrl"]}/syosi/error-download-excel`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "content-type": "multipart/form-data",
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );

    // Excelファイルのダウンロード
    let blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `商品ステータス入力_エラー内容.xlsx`;
    link.click();
    isUploading.value = false;
  } catch (error) {
    alert("エラー内容の取得に失敗しました");
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["PReference", {
      Show_KaniSearch: _unref(isActive_KaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActive_KaniFlg: _unref(isActive_KaniFlg),
      isActive_SyosaiFlg: _unref(isActive_SyosaiFlg),
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onOnSearch: onSearch,
      onChangeToggleArea: changeToggleArea
    }, null, 8, ["isActive_KaniFlg", "isActive_SyosaiFlg", "isActive_SidebarFlg", "searchAreaToggle"]),
    (_unref(modalVisible_memo))
      ? (_openBlock(), _createBlock(ModalOrderSearchMemo, {
          key: 0,
          isVisible: _unref(modalVisible_memo),
          selectedProduct: _unref(selectedProduct),
          onClose: closeModal,
          onUpdateBikou: updateBikou
        }, null, 8, ["isVisible", "selectedProduct"]))
      : _createCommentVNode("", true),
    (_unref(modalVisible_van))
      ? (_openBlock(), _createBlock(ModalOrderSearchVan, {
          key: 1,
          isVisible: _unref(modalVisible_van),
          selectedProduct: _unref(selectedProduct),
          onClose: closeModal,
          onUpdateStatus: updateStatus
        }, null, 8, ["isVisible", "selectedProduct"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Paginate), {
          "page-count": numberOfTotalPage.value,
          "hide-prev-next": true,
          "page-range": 3,
          "prev-text": '<',
          "next-text": '>',
          "container-class": 'pagination',
          "page-class": 'page-item',
          "page-link-class": 'page-item--link',
          "active-class": 'page-item--active',
          "click-handler": onClickPage,
          "force-page": currentPage.value
        }, null, 8, ["page-count", "force-page"]),
        _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
          [_vShow, _unref(search_result).length]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["PReference_Button GreenSmall", {
            disabled_btn: isDownloading.value,
          }]),
          onClick: downloadFile,
          disabled: isDownloading.value
        }, [
          (!isDownloading.value)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "download",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (isDownloading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          _createTextVNode(" ダウンロード ")
        ], 10, _hoisted_4),
        _createElementVNode("input", {
          onChange: uploadFile,
          onClick: resetFile,
          type: "file",
          ref_key: "inputFile",
          ref: inputFile,
          accept: ".xlsx",
          style: {"display":"none"}
        }, null, 544),
        _createElementVNode("button", {
          onClick: onClickUpload,
          class: _normalizeClass(["PReference_Button GreenSmall", {
            disabled_btn: isUploading.value,
            Move_With_Enter: !isUploading.value,
          }]),
          disabled: isUploading.value
        }, [
          (!isUploading.value)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "upload",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (isUploading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7))
            : _createCommentVNode("", true),
          _hoisted_8
        ], 10, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["PReference_TableContainer", tableHeight()])
    }, [
      _createElementVNode("table", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (result, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_11, [
                _createTextVNode(_toDisplayString(result.syosiCd), 1),
                _hoisted_12,
                _createTextVNode(_toDisplayString(result.isbn), 1)
              ]),
              _createElementVNode("td", _hoisted_13, _toDisplayString(result.title), 1),
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(result.itemRemarks), 1),
                    (
                      result.itemRemarks !== null &&
                      result.remarksDeadline === '9999-12-31'
                    )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, " (無期限) "))
                      : (result.remarksDeadline)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, " (" + _toDisplayString(result.remarksDeadline) + ") ", 1))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    (
                      result.itemRemarks == null &&
                      result.remarksDeadline == null
                    )
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          class: "PReference_Table_Icon",
                          onClick: ($event: any) => (showModal('ModalOrderSearchMemo', result)),
                          icon: ['far', 'pen-to-square']
                        }, null, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          class: "PReference_Table_Icon",
                          onClick: ($event: any) => (showModal('ModalOrderSearchMemo', result)),
                          icon: "pen-to-square"
                        }, null, 8, ["onClick"]))
                  ])
                ])
              ]),
              _createElementVNode("td", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("p", _hoisted_23, _toDisplayString(result.vanStatusName), 1),
                    (
                      result.vanStatusName !== null &&
                      result.toUpdateStatusDate === '9999-12-31'
                    )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, " (無期限) "))
                      : (
                      result.fromUpdateStatusDate && result.toUpdateStatusDate
                    )
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, " (" + _toDisplayString(result.fromUpdateStatusDate) + "~" + _toDisplayString(result.toUpdateStatusDate) + ") ", 1))
                        : _createCommentVNode("", true)
                  ]),
                  (result.vanStatusName == null)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        class: "PReference_Table_Icon",
                        onClick: ($event: any) => (showModal('ModalOrderSearchVan', result)),
                        icon: ['far', 'pen-to-square']
                      }, null, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        class: "PReference_Table_Icon",
                        onClick: ($event: any) => (showModal('ModalOrderSearchVan', result)),
                        icon: "pen-to-square"
                      }, null, 8, ["onClick"]))
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(result.items), 1),
              _createElementVNode("td", null, _toDisplayString(result.returnItems), 1),
              _createElementVNode("td", null, _toDisplayString(result.hontaiPrice), 1),
              _createElementVNode("td", null, _toDisplayString(result.janCd), 1),
              _createElementVNode("td", null, _toDisplayString(result.torioki), 1),
              _createElementVNode("td", null, _toDisplayString(result.inputSum), 1),
              _createElementVNode("td", null, _toDisplayString(result.holdSum), 1),
              _createElementVNode("td", null, _toDisplayString(result.series), 1),
              _createElementVNode("td", null, _toDisplayString(result.category), 1),
              _createElementVNode("td", null, _toDisplayString(result.zsName), 1),
              _createElementVNode("td", null, _toDisplayString(result.releaseDate), 1),
              _createElementVNode("td", null, _toDisplayString(result.slip), 1),
              _createElementVNode("td", null, _toDisplayString(result.cover), 1),
              _createElementVNode("td", null, _toDisplayString(result.obi), 1),
              _createElementVNode("td", null, _toDisplayString(result.bookCase), 1),
              _createElementVNode("td", null, _toDisplayString(result.kaisoSchduledDate), 1),
              _createElementVNode("td", null, _toDisplayString(result.kaisoSchduledQuantity), 1),
              _createElementVNode("td", null, _toDisplayString(result.juhanSchduledDate), 1),
              _createElementVNode("td", null, _toDisplayString(result.juhanSchduledQuantity), 1),
              _createElementVNode("td", null, _toDisplayString(result.latestPrints), 1),
              _createElementVNode("td", _hoisted_26, [
                (result.cutting === true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "断"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(result.author), 1)
            ]))
          }), 128))
        ])
      ]),
      (!_unref(search_result).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, " ※検索結果はありません "))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})